import { render, staticRenderFns } from "./SortProductsItem.vue?vue&type=template&id=f8386afc&"
import script from "./SortProductsItem.vue?vue&type=script&lang=js&"
export * from "./SortProductsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports